module.exports = __webpack_public_path__ + "img/check.429f24e3.png";